import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Calendar, User, Clock } from 'lucide-react';

export const UpcomingAppointments = ({ appointments }) => {
  // Filter future appointments and sort by date
  const upcoming = appointments
    .filter(apt => new Date(apt.date) >= new Date())
    .sort((a, b) => new Date(a.date) - new Date(b.date))
    .slice(0, 5);

  return (
    <Card className="bg-light/5 border-gold/20">
      <CardHeader>
        <CardTitle className="text-white flex items-center gap-2">
          <Calendar className="w-5 h-5 text-gold" />
          Prochains Rendez-vous ({upcoming.length})
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-3">
        {upcoming.length === 0 ? (
          <p className="text-gray-400 text-center py-4 text-sm">
            Aucun rendez-vous à venir
          </p>
        ) : (
          upcoming.map((apt) => (
            <div
              key={apt.id}
              className="bg-gradient-to-r from-gold/10 to-transparent p-3 rounded-sm border border-gold/20 hover:border-gold/40 transition-colors"
            >
              <div className="flex items-start justify-between">
                <div className="flex-1">
                  <div className="flex items-center gap-2 mb-1">
                    <User className="w-3 h-3 text-gold" />
                    <span className="text-white font-semibold text-sm">
                      {apt.client_name}
                    </span>
                  </div>
                  <div className="flex items-center gap-2 text-xs text-gray-300">
                    <Calendar className="w-3 h-3" />
                    <span>
                      {new Date(apt.date).toLocaleDateString('fr-FR', {
                        weekday: 'short',
                        day: 'numeric',
                        month: 'short'
                      })}
                    </span>
                    <Clock className="w-3 h-3 ml-2" />
                    <span>{apt.time}</span>
                  </div>
                </div>
                <span className="text-xs px-2 py-1 rounded-full bg-neon/20 text-neon">
                  {apt.status}
                </span>
              </div>
            </div>
          ))
        )}
      </CardContent>
    </Card>
  );
};
